import medal11White from 'assets/images/medals/medal-1-1-white.webp';
import medal11 from 'assets/images/medals/medal-1-1.webp';
import medal12White from 'assets/images/medals/medal-1-2-white.webp';
import medal12 from 'assets/images/medals/medal-1-2.webp';
import medal13White from 'assets/images/medals/medal-1-3-white.webp';
import medal13 from 'assets/images/medals/medal-1-3.webp';
import medal14White from 'assets/images/medals/medal-1-4-white.webp';
import medal14 from 'assets/images/medals/medal-1-4.webp';
import medal15White from 'assets/images/medals/medal-1-5-white.webp';
import medal15 from 'assets/images/medals/medal-1-5.webp';
import medal21White from 'assets/images/medals/medal-2-1-white.webp';
import medal21 from 'assets/images/medals/medal-2-1.webp';
import medal22White from 'assets/images/medals/medal-2-2-white.webp';
import medal22 from 'assets/images/medals/medal-2-2.webp';
import medal23White from 'assets/images/medals/medal-2-3-white.webp';
import medal23 from 'assets/images/medals/medal-2-3.webp';
import medal24White from 'assets/images/medals/medal-2-4-white.webp';
import medal24 from 'assets/images/medals/medal-2-4.webp';
import medal25White from 'assets/images/medals/medal-2-5-white.webp';
import medal25 from 'assets/images/medals/medal-2-5.webp';
import trophy11 from 'assets/images/trophies/trophy-1-1.webp';
import trophy12 from 'assets/images/trophies/trophy-1-2.webp';
import trophy13 from 'assets/images/trophies/trophy-1-3.webp';
import trophy14 from 'assets/images/trophies/trophy-1-4.webp';
import trophy15 from 'assets/images/trophies/trophy-1-5.webp';
import trophy21 from 'assets/images/trophies/trophy-2-1.webp';
import trophy22 from 'assets/images/trophies/trophy-2-2.webp';
import trophy23 from 'assets/images/trophies/trophy-2-3.webp';
import trophy24 from 'assets/images/trophies/trophy-2-4.webp';
import trophy25 from 'assets/images/trophies/trophy-2-5.webp';

export const AchievementsColorName = (level: number) => {
  const colors = [
    {color: 'Laranja'},
    {color: 'Verde'},
    {color: 'Azul'},
    {color: 'Rosa'},
    {color: 'Lilás'},
  ];

  return colors[level - 1]?.color;
};

// cycles 1 and 2
const images = {
  1: {
    medals: [
      {src: medal11},
      {src: medal12},
      {src: medal13},
      {src: medal14},
      {src: medal15},
    ],
    trophies: [
      {src: trophy11},
      {src: trophy12},
      {src: trophy13},
      {src: trophy14},
      {src: trophy15},
    ],
  },
  2: {
    medals: [
      {src: medal21},
      {src: medal22},
      {src: medal23},
      {src: medal24},
      {src: medal25},
    ],
    trophies: [
      {src: trophy21},
      {src: trophy22},
      {src: trophy23},
      {src: trophy24},
      {src: trophy25},
    ],
  },
};

const imagesHovered = {
  1: [
    {src: medal11White},
    {src: medal12White},
    {src: medal13White},
    {src: medal14White},
    {src: medal15White},
  ],
  2: [
    {src: medal21White},
    {src: medal22White},
    {src: medal23White},
    {src: medal24White},
    {src: medal25White},
  ],
};

enum AchievementsTypes {
  medals = 'medals',
  trophies = 'trophies',
}

export interface AchievementsProps {
  type: AchievementsTypes | string;
  level: number;
  cycle: number;
  text?: boolean;
  isHovered?: boolean;
  size?: number;
}

const Achievements: React.FC<AchievementsProps> = ({
  level,
  cycle,
  text,
  isHovered,
  type,
  size = 75,
}) => {
  const levels = level - 1; // decrement for selecting correct image

  return (
    <div className="Achievements">
      <img
        alt="Medalha"
        className="icon"
        src={
          isHovered
            ? (imagesHovered as any)[cycle][levels].src
            : (images as any)[cycle][type][levels]?.src
        }
        height={size}
      />
      <>{text ? <div className="text">Nível {level}</div> : ''}</>
    </div>
  );
};

export default Achievements;
